import { useState as C, useRef as y, useCallback as p, useEffect as g } from "react";
import { normalizeSnapPoint as D, getOffscreenTransform as $ } from "./index.es902.js";
const M = (n, h, t, x = [], s) => {
  const [u, b] = C(!1), c = y(null), i = y(!1), T = y(!1), e = y(h), l = p(
    (r, a = !0) => {
      if (!t.current) return;
      const f = D(r), m = t.current ? e.current === "left" || e.current === "right" ? t.current.offsetWidth : t.current.offsetHeight : 0, o = f * m;
      t.current.style.transition = a ? "transform 300ms ease-out" : "none", e.current === "bottom" ? t.current.style.transform = `translateY(${o}px)` : e.current === "top" ? t.current.style.transform = `translateY(-${o}px)` : e.current === "right" ? t.current.style.transform = `translateX(${o}px)` : t.current.style.transform = `translateX(-${o}px)`;
    },
    [t]
  ), z = (r) => {
    T.current = r;
  };
  g(() => {
    n || (e.current = h);
  }, [h, n]), g(() => {
    if (c.current && (clearTimeout(c.current), c.current = null), n)
      b(!0), i.current = !1;
    else if (u) {
      const r = t.current;
      r && (r.style.transition = "transform 300ms ease-out", r.style.transform = $(e.current)), c.current = setTimeout(() => {
        b(!1), c.current = null;
      }, 300);
    }
  }, [n, t, u]), g(() => {
    if (!u || !t.current || !n || i.current) return;
    const r = t.current;
    r.style.transition = "none", r.style.transform = $(e.current), r.offsetWidth, requestAnimationFrame(() => {
      r.style.transition = "transform 300ms ease-out", s && x.includes(s) ? l(s, !0) : r.style.transform = "", i.current = !0;
    });
  }, [u, n, s, x, t, l]), g(() => {
    n && u && i.current && s && !T.current && l(s, !0);
  }, [s, l, n, u]);
  const A = p(() => {
    var m, o;
    if (!t.current) return 0;
    const r = window.getComputedStyle(t.current), a = r.transform || r.webkitTransform;
    if (a === "none") return 0;
    const f = (o = (m = a.match(/matrix.*\((.+)\)/)) == null ? void 0 : m[1]) == null ? void 0 : o.split(", ");
    return f ? e.current === "left" || e.current === "right" ? Math.abs(parseFloat(f[4])) : Math.abs(parseFloat(f[5])) : 0;
  }, [t]);
  return {
    rendered: u,
    applySnapPoint: l,
    setIsDragging: z,
    getCurrentOffset: A
  };
};
export {
  M as useDrawerAnimation
};
//# sourceMappingURL=index.es5752.js.map
